<script lang="ts">
  import ReplyCard from "$components/forum/cards/Reply.svelte";
  import GutterMenu from "$components/editor/extensions/+shared/GutterMenu.svelte";
  import api from "$utils/api";
  import { thread, transformPost } from "app/stores/thread";
  import { NodeViewWrapper } from "svelte-tiptap";
  import { onMount } from "svelte";
  import { communitySlug } from "app/stores/community";
  import type { NodeViewProps } from "@tiptap/core";

  export let node: NodeViewProps["node"];
  export let deleteNode: NodeViewProps["deleteNode"];
  export let isEditable: boolean;
  $$restProps; // prevent svelte unused props warning

  const { threadUuid, threadSlug, forumSpaceSlug, forumSpaceUuid, replySeqNum } = node.attrs;
  const reply = $thread.posts[replySeqNum];

  onMount(() => {
    api
      .communitiesPostsRetrieve(
        {
          communitySlug: $communitySlug,
          uuid: replySeqNum,
        },
        {
          params: {
            forum_thread_uuid: threadUuid,
          },
        }
      )
      .then((resp) => {
        thread.addPosts([transformPost(resp.data)]);
      });
  });
</script>

<NodeViewWrapper class="group relative w-5/6">
  {#if isEditable}
    <GutterMenu on:delete-block={deleteNode} />
  {/if}

  {#if reply}
    <ReplyCard
      post={reply}
      isReply
      isQuote
      focused={false}
      canReply={false}
      isReplyUpvotesEnabled={false}
      {forumSpaceUuid}
      {threadUuid}
      {threadSlug}
      {forumSpaceSlug}
    />
  {/if}
</NodeViewWrapper>
